import { render } from "./clubcard-loyalty.html?vue&type=template&id=02b9e23b&scoped=true&ts=true"
import script from "./clubcard-loyalty.vue?vue&type=script&lang=ts"
export * from "./clubcard-loyalty.vue?vue&type=script&lang=ts"

import "./clubcard-loyalty.scss?vue&type=style&index=0&id=02b9e23b&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b9e23b"]])

export default __exports__